<script>
  import lodash from "lodash";
  import WelcomeScreen from "./WelcomeScreen.svelte";
  import Questionnaire from "./Questionnaire.svelte";
  import DesignTool from "./DesignTool.svelte";
  import questions from "./questions";
  import FavoriteImage from "./FavoriteImage.svelte";
  import Preview from "./Preview.svelte";
  import Checkout from "./checkout.svelte";
  let src = "/assets/logo-11.jpg";
  let name = "logo";
  // import lastquestions from "./lastquestions";

  let shuffledQuestions = lodash.shuffle(questions);

  //export let name;
  let shoppingPhase = "welcome"; //welcome

  let personality = {
    minimalism: 0,
    maximalism: 0,
    symmetry: 0,
    asymmetry: 0,
    light: 0,
    dark: 0,
    favoriteImageIndex: 0,
  };
  let designImageData;

  let activeQuestionStep = 1;

  function goToQuestionnaire() {
    shoppingPhase = "questionnaire";
  }

  function goToNextStep(choice) {
    personality[choice] += 1;
    activeQuestionStep += 1;

    if (activeQuestionStep > questions.length) {
      shoppingPhase = "favoriteImage";
    }
  }

  function chooseFavoriteImage(favoriteImageIndex) {
    personality.favoriteImageIndex = favoriteImageIndex;
  }

  function goToDesignTool() {
    shoppingPhase = "design";
  }

  function goToPreviewScreen(data) {
    designImageData = data;
    shoppingPhase = "preview";
  }

  function goToCheckout() {
    shoppingPhase = "checkout";
  }
</script>

<main>
  <img {src} alt="logo" />
  {#if shoppingPhase === "welcome"}
    <WelcomeScreen {goToQuestionnaire} />
  {:else if shoppingPhase === "questionnaire"}
    <Questionnaire
      questions={shuffledQuestions}
      step={activeQuestionStep}
      {goToNextStep}
    />
  {:else if shoppingPhase === "favoriteImage"}
    <FavoriteImage
      {goToDesignTool}
      {chooseFavoriteImage}
      favoriteImageIndex={personality.favoriteImageIndex}
    />
  {:else if shoppingPhase === "design"}
    <DesignTool {personality} {goToPreviewScreen} />
  {:else if shoppingPhase === "preview"}
    <Preview {personality} {goToCheckout} {designImageData} />
  {:else if shoppingPhase === "checkout"}
    <Checkout {personality} />
  {/if}
</main>

<style>
  main {
    text-align: center;
    max-width: 240px;
    margin: 0 auto;
    background: #f0f0f0;
  }

  img {
    width: 71px;
    height: 42.5px;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
